export const ETRIS02_ARSummary = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "AR Summary",
    binding: {
      data: {
        columns: [
          {
            name: "Customer Code",
            columnName: "CustomerCode",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Name",
            columnName: "CustomerName",
            width: "250px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Address",
            columnName: "CustomerAddress",
            width: "350px",
            align: "left",
            sortable: true
          },
          {
            name: "Ship To Code",
            columnName: "ShipToCode",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Ship To Address",
            columnName: "ShipToAddress",
            width: "350px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Classification",
            columnName: "CustomerClassification",
            width: "220px",
            align: "left",
            sortable: true
          },
          {
            name: "Order Type",
            columnName: "OrderType",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Invoice Number",
            columnName: "InvoiceNumber",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "DR No.",
            columnName: "DRNo",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Invoice Date",
            columnName: "InvoiceDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Due Date",
            columnName: "DueDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Check No.",
            columnName: "CheckNo",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Check Date",
            columnName: "CheckDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Credit Terms",
            columnName: "CreditTerms",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Dispatched Date",
            columnName: "DispatchedDate",
            width: "200px",
            align: "left",
            sortable: true
          },
          {
            name: "Delivery Date",
            columnName: "DeliveryDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Forwarder / Courier",
            columnName: "ForwarderCourier",
            width: "200px",
            align: "left",
            sortable: true
          },
          {
            name: "SI Amount",
            columnName: "SIAmount",
            width: "150px",
            align: "right",
            sortable: true
          },
          {
            name: "Allocated PDC",
            columnName: "AllocatedPDC",
            width: "150px",
            align: "right",
            sortable: true
          },
          {
            name: "Allocated Cash",
            columnName: "AllocatedCash",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Not Yet Due",
            columnName: "NotYetDue",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Current",
            columnName: "Current",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "One Month",
            columnName: "OneMonth",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Two Months",
            columnName: "TwoMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Three Months",
            columnName: "ThreeMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Four Months",
            columnName: "FourMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Five Months",
            columnName: "FiveMonths",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Six Months Over",
            columnName: "SixMonthsOver",
            width: "180px",
            align: "right",
            sortable: true
          },
          {
            name: "Total Balance",
            columnName: "TotalBalance",
            width: "150px",
            align: "right",
            sortable: true
          },
          {
            name: "Principal",
            columnName: "Principal",
            width: "120px",
            align: "right",
            sortable: true
          },
          {
            name: "Area",
            columnName: "Area",
            width: "150px",
            align: "center",
            sortable: true
          },
          {
            name: "Region",
            columnName: "Region",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Province",
            columnName: "Province",
            width: "150px",
            align: "left",
            sortable: true
          }
        ],
        title: "CustomerCode",
        onLoad: "Pgn.IS02",
        subtotal: true,
        pagination: {
          show: true
        },
        endpoint: "ETRIS02",
        parameters: [
          {
            key: "PageIndex",
            value: "1"
          },
          {
            key: "ResultsPerPage",
            value: "10"
          }
        ]
      },
      context: {
        point: {
          onClick: {}
        }
      }
    }
  }
};